import type { RunSummary, ScenarioSummary } from "./types";

/** Start-screen groups, in display order. Topic only: a group never hints at the lesson. */
export const SCENARIO_GROUPS: { id: string; label: string; blurb: string }[] = [
  { id: "start", label: "Start here", blurb: "The full eight weeks at Bellamy & Howe. Choose your seat: managing partner, practice manager or operations director." },
  { id: "people", label: "People", blurb: "Absence, departures, new joiners and how people work." },
  { id: "systems", label: "Systems and technology", blurb: "New systems, new tools, and when technology goes wrong." },
  { id: "money", label: "Money and performance", blurb: "Measures, billing and cash." },
  { id: "regulation", label: "Regulation", blurb: "Inspections, reports and the regulator." },
  { id: "partnership", label: "Partnership and strategy", blurb: "Succession, profit share, mergers and premises." },
];

export interface ScenarioGroupView {
  id: string; label: string; blurb: string;
  scenarios: ScenarioSummary[];
  /** Runs in progress in this group (shown on the collapsed heading). */
  activeRuns: number;
}

/** Group scenarios for the start screen. Unknown groups fall into "Start here"; empty groups are left out. */
export function groupScenarios(scenarios: ScenarioSummary[], runs: RunSummary[]): ScenarioGroupView[] {
  const known = new Set(SCENARIO_GROUPS.map((g) => g.id));
  return SCENARIO_GROUPS.map((g) => {
    const list = scenarios.filter((s) => (known.has(s.group ?? "") ? s.group : "start") === g.id);
    const ids = new Set(list.map((s) => s.id));
    return { ...g, scenarios: list, activeRuns: runs.filter((r) => ids.has(r.scenarioId) && r.status === "active").length };
  }).filter((g) => g.scenarios.length > 0);
}

/** A group starts open if it is "Start here" or holds a run in progress. */
export function startsOpen(g: ScenarioGroupView): boolean {
  return g.id === "start" || g.activeRuns > 0;
}

export function groupSummaryNote(g: ScenarioGroupView): string {
  const n = g.scenarios.length;
  const parts = [`${n} scenario${n === 1 ? "" : "s"}`];
  if (g.activeRuns) parts.push(`${g.activeRuns} in progress`);
  return parts.join(" · ");
}
